<script setup lang="ts">
  import { FlowTravelersWidget } from '@/widgets/Flow'
  import { useApiRequestsAbort } from '@/shared/composables'

  useApiRequestsAbort()
</script>

<template>
  <FlowTravelersWidget />
</template>
